import SelectNew from './SelectNew';

export default SelectNew;
